const secrets = {
    third_party_token_set: {
        token_not_found: 'Token-Datensatz nicht gefunden.',
        access_token_expired: 'Das Zugriffstoken ist abgelaufen. Bitte verbinde dein Konto erneut.',
    },
};
export default Object.freeze(secrets);
